import i18n from 'app-i18n';
import * as yup from 'yup';

export const refundFormSchema = yup.object().shape({
  fullAmount: yup.string().default('partialAmount'),
  refundAmount: yup
    .number()
    .required()
    .test('is-max-refundable', '', (value, context) => {
      // @ts-ignore
      const { parent, options, createError } = context;
      const { fullAmount } = parent;
      // @ts-ignore
      const { refundableAmount } = options;
      if (
        !!refundableAmount &&
        refundableAmount < value &&
        fullAmount !== 'fullAmount'
      )
        return createError({
          message: i18n.t(
            'forms.fields.refundForm.amount.errors.maxRefundableAmount',
            {
              refundableAmount: refundableAmount,
            },
          ),
        });
      return true;
    }),
  refundReason: yup.string().required(),
  requestedBy: yup.string().required(),
  emailReceipt: yup.boolean().default(false),
});
